/**
 * API 환경 변수 설정
 * 모든 API URL을 중앙에서 관리
 */
export const API_CONFIG = {
  AUTH_URL: import.meta.env.VITE_AUTH_SERVER_URL,
  SURVEY_URL: import.meta.env.VITE_SURVEY_SERVER_URL,
  PATIENT_URL: import.meta.env.VITE_PATIENT_SERVER_URL,
  TEMP_PAYHUB_URL: import.meta.env.VITE_TEMP_PAYHUB_SERVER_URL,
  PAYHUB_URL: import.meta.env.VITE_PAYHUB_SERVER_URL,
  QUESTIONNAIRE_URL: import.meta.env.VITE_QUESTIONNAIRE_SERVER_URL,
  SCAN_URL: import.meta.env.VITE_SCAN_SERVER_URL || 'https://scan2-api.dev.ybrainlab.com',
  SCAN_MINI_URL: import.meta.env.VITE_SCAN_MINI_SERVER_URL,
  STIM_URL: import.meta.env.VITE_STIM_SERVER_URL,
  MANUFACTURE_URL: import.meta.env.VITE_MANUFACTURE_SERVER_URL,
  AUTH_CLIENT_SECRET: import.meta.env.VITE_AUTH_CLIENT_SECRET || 'xp8mpKKRo0ATgsMYiJRU',
  NOTICE_URL: import.meta.env.VITE_NOTICE_URL || '',
  NOTICE_API_KEY: import.meta.env.VITE_NOTICE_API_KEY || '',
  RENDER_URL: import.meta.env.VITE_RENDER_SERVER_URL || '',
  QX_DELIVERY_URL: import.meta.env.VITE_QX_DELIVERY_SERVER_URL || '',
  STIM_HOME_URL: import.meta.env.VITE_STIM_HOME_SERVER_URL || '',
  CONTRACT_URL: import.meta.env.VITE_CONTRACT_SERVER_URL || '',
  // WebSocket 설정
  SCAN_WS_BASE_URL: import.meta.env.VITE_SCAN_WS_BASE_URL || 'wss://scan2-api.dev.ybrainlab.com',
  // feed 서버(릴레이) — 발신 서버들의 feed.events 를 org 단위로 fan-out 하는 통합 실시간 채널
  FEED_URL: import.meta.env.VITE_FEED_SERVER_URL || '',

  // 외부 서비스 URL
  RESEARCH_WEB_URL: import.meta.env.VITE_RESEARCH_WEB_URL || '',
  TDCS_GUIDE_URL: import.meta.env.VITE_TDCS_GUIDE_URL || '',
  // Somzz 설정
  SOMZZ_API_URL: import.meta.env.VITE_SOMZZ_API_URL || '',
  SOMZZ_API_KEY: import.meta.env.VITE_SOMZZ_API_KEY || '',
  PORTNOE_STORE_ID: import.meta.env.VITE_PORTNOE_STORE_ID || '',
  PORTNOE_CHANNEL_KEY: import.meta.env.VITE_PORTNOE_CHANNEL_KEY || '',
  // 기타 설정
  ENV: (import.meta.env.VITE_ENV as 'dev' | 'qa' | 'stg' | 'prod') || 'dev',
  COOKIE_PREFIX: import.meta.env.VITE_COOKIE_PREFIX || 'mindd',
  SURVEY_BOOTPAY_ID: import.meta.env.VITE_SURVEY_BOOTPAY_ID || '',
} as const;
